import IdentityTagAssignment from './RosterIdentityTagAssignment';

export default IdentityTagAssignment;
